var _style, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1C75BC;stroke-width:0.75;stroke-miterlimit:2.6131;}\n\t.st1{fill:#1B75BC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "53.8,21.2 31.7,23.5 58.4,10.1 54.8,16.1 59.8,15.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.7,23.5c-11.5-1.4-19.3-5.4-23.5-12C9.7,23.7,13.9,35,20.6,45.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.2,11.5C4.6,16.9,6.7,24.8,11.4,26l-5.2-0.3c0.3,6.3,3.4,9.4,8.9,9.7l-4.5,1.7c2,4.9,5.6,7.2,10.1,8.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.2,
    y1: 25.7,
    x2: 15.1,
    y2: 35.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10.6,
    y1: 37.1,
    x2: 20.6,
    y2: 45.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,21.2C52.9,45,39.2,55.1,20.3,54.5c-5.1-0.2-12.3-2.3-16.1-4.6c6.8,0,12.1-1,15.7-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.1,13.8c-7.9-9.3-22.2-2.2-19.4,9.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "51.1,13.8 43,47.7 20.6,45.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "54.8,16.1 31.7,23.5 43,47.7 11.4,26 31.7,23.5 20.6,45.2  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 32.1,
    cy: 23.1,
    r: 2.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 42.8,
    cy: 47.2,
    r: 2.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20.1,
    cy: 45.4,
    r: 1.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 11.7,
    cy: 26.3,
    r: 1.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 50.3,
    cy: 17.6,
    r: 1.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 5.1,
    cy: 50.2,
    r: 1.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.db82c12c50535339ea03e20a837ab739.svg";
export { ForwardRef as ReactComponent };